import { render, staticRenderFns } from "./EventCompanyDialog.vue?vue&type=template&id=0d703774&scoped=true"
import script from "./EventCompanyDialog.vue?vue&type=script&lang=ts"
export * from "./EventCompanyDialog.vue?vue&type=script&lang=ts"
import style0 from "./EventCompanyDialog.vue?vue&type=style&index=0&id=0d703774&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d703774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d703774')) {
      api.createRecord('0d703774', component.options)
    } else {
      api.reload('0d703774', component.options)
    }
    module.hot.accept("./EventCompanyDialog.vue?vue&type=template&id=0d703774&scoped=true", function () {
      api.rerender('0d703774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/EventCompanyDialog.vue"
export default component.exports